<template>
  <ul class="navbar-nav">
    <router-link :title="gatewaysAlarmsTitle | capitalize" :to="{name:'gatewaysAlarms'}" tag="li" class="nav-item notification-link">
      <a id="gatewaysAlarmsLink" class="nav-link">
        <i class="icon-gateway" />
        <alarm-badge :alarm-count="gatewaysAlarmCount" position-absolute />
      </a>
    </router-link>

    <router-link :title="endDevicesAlarmsTitle | capitalize" :to="{name:'endDevicesAlarms'}" tag="li" class="nav-item notification-link">
      <a id="endDevicesAlarmsLink" class="nav-link">
        <i class="icon-end-device" />
        <alarm-badge :alarm-count="endDevicesAlarmCount" position-absolute />
      </a>
    </router-link>

    <router-link :title="networkAlarmsTitle | capitalize" :to="{name:'networkAlarms'}" tag="li" class="nav-item notification-link">
      <a id="networkAlarmsLink" class="nav-link">
        <i class="icon-signal" />
        <alarm-badge :alarm-count="networkAlarmCount" position-absolute />
      </a>
    </router-link>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(['gatewaysAlarmCount', 'endDevicesAlarmCount', 'networkAlarmCount', 'alarmsRefresh']),

    gatewaysAlarmsTitle () {
      return this.gatewaysAlarmCount >= 0 ? this.$t('alarms:onGateways', { count: this.gatewaysAlarmCount }) : this.$t('alarms:onError')
    },
    endDevicesAlarmsTitle () {
      return this.endDevicesAlarmCount >= 0 ? this.$t('alarms:onEndDevices', { count: this.endDevicesAlarmCount }) : this.$t('alarms:onError')
    },
    networkAlarmsTitle () {
      return this.networkAlarmCount >= 0 ? this.$t('alarms:onNetwork', { count: this.networkAlarmCount }) : this.$t('alarms:onError')
    }
  },

  watch: {
    alarmsRefresh () {
      this.getLastGatewayEventsCounters()
      this.getRncGatewaysLastEventsCounters()
      this.getLastLnsEventsCounters()
    }
  },

  mounted () {
    this.getLastGatewayEventsCounters()
    this.getRncGatewaysLastEventsCounters()
    this.getLastLnsEventsCounters()
  },

  beforeDestroy () {
    clearTimeout(this.timeoutLastBscEventsCounters)
    clearTimeout(this.timeoutLastRncEventsCounters)
    clearTimeout(this.timeoutLastLnsEventsCounters)
  },

  methods: {
    getLastGatewayEventsCounters: function () {
      clearTimeout(this.timeoutLastBscEventsCounters)

      // In case the promise ended after the destruction of the component
      // Check the component status to only relaunch the polling when component is not destroyed
      if (this._isDestroyed || this._isBeingDestroyed) return

      this.$store.dispatch('getLastGatewayEventsCounters', { loader: false, defaultErrorMessage: false })
        .finally(() => {
          this.timeoutLastBscEventsCounters = setTimeout(this.getLastGatewayEventsCounters, this.alarmsRefresh)
        })
    },

    getRncGatewaysLastEventsCounters: function () {
      clearTimeout(this.timeoutLastRncEventsCounters)

      // In case the promise ended after the destruction of the component
      // Check the component status to only relaunch the polling when component is not destroyed
      if (this._isDestroyed || this._isBeingDestroyed) return

      this.$store.dispatch('getRncGatewaysLastEventsCounters', { loader: false, defaultErrorMessage: false })
        .finally(() => {
          this.timeoutLastRncEventsCounters = setTimeout(this.getRncGatewaysLastEventsCounters, this.alarmsRefresh)
        })
    },

    getLastLnsEventsCounters: function () {
      clearTimeout(this.timeoutLastLnsEventsCounters)

      // In case the promise ended after the destruction of the component
      // Check the component status to only relaunch the polling when component is not destroyed
      if (this._isDestroyed || this._isBeingDestroyed) return

      this.$store.dispatch('getLastLnsEventsCounters', { loader: false, defaultErrorMessage: false })
        .finally(() => {
          this.timeoutLastLnsEventsCounters = setTimeout(this.getLastLnsEventsCounters, this.alarmsRefresh)
        })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  .notification-link {
    display: inline-flex;
    align-items: stretch;

    a.nav-link {
      position: relative;
      display: flex;
      align-items: center;
      padding: 0.6rem 1rem;
    }

    i {
      color: $primary;
      transition: all 0.4s;
    }

    &:hover i {
      color: $secondary;
    }
  }
</style>
